import { render, staticRenderFns } from "./giftInventoryLogDetail.vue?vue&type=template&id=5933bf79"
import script from "./giftInventoryLogDetail.vue?vue&type=script&lang=js"
export * from "./giftInventoryLogDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports